import { forwardRef } from 'react';

import { Link, type LinkProps } from '@/components/Link';

import { COACH_PATH } from './constants';

export const LinkCoach = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to: _to, ...rest }, ref) => {
    const to = `${COACH_PATH}${_to}`;

    return <Link ref={ref} to={to} {...rest} />;
  }
);

LinkCoach.displayName = 'LinkCoach';
